<template>
  <div class="group-rounded-box row-py-clear">
    <el-row no-gutters>
      <el-col :md="8" :lg="6" :xl="5" :class="{ 'border-right': !$breakpoint.smAndDown }" v-if="!widget">
        <el-row class="pl-3">
          <h2 class="font-weight-bolder">Manage Delivery Locations</h2>
        </el-row>
        <el-row class="pl-3 pt-3">
          <el-button class="btn btn-actionable" @click="addNewDeliveryLocation">
            <span class="font-weight-bold clickableLink" :class="$breakpoint.smAndDown ? 'h7' : ''"> </span>+ Add Delivery
            Location
          </el-button>
        </el-row>
        <el-row class="pl-3 py-3">
          <el-col :xs="20" :sm="18" :md="17">
            <el-input placeholder="Search location" v-model="searchLocation" clearable>
              <template slot="prepend"><i class="fas fa-search fa-lg"></i></template>
            </el-input>
          </el-col>
        </el-row>
        <el-tabs ref="locationTabs" :key="renderKey" class="pl-3 pr-2 scrollable widthFix" :tab-position="$breakpoint.mdAndDown ? 'top' : 'left'" :value="getSelectedTab" type="card" stretch 
            @tab-click="changeTab">
          <el-tab-pane
            v-for="(item, index) in filteredExisitingDeliveryLocations"
            :key="index"
            :label="getDeliveryLocationLabel(item.name, item.address)"
            :name="index.toString()"
          ></el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :md="widget ? 24 : 16" :xl="widget ? 24 : 18" class="pt-0" style="min-height: 670px;">
        <newDeliveryLocation
          v-show="showLocationDetails"
          :currentSelectedLocation="currentSelectedLocation"
          ref="newDeliveryLocation"
          :creatingNewLocation="creatingNewLocation"
          :key="currentSelectedLocation._id"
          :widget="widget"
          :tabsLength="tabsLength"
          :tabIndex="tabIndex"
          :buyerAccountId="buyerAccountId"
          :deliveryLocationChangeOccured.sync="deliveryLocationChangeOccured"
          @deleteLocation="deleteLocation"
          @newDeliveryLocationCreated="newDeliveryLocationCreated"
          @deliveryLocationUpdated="deliveryLocationUpdated"
          @emitNext="emitNext"
          @emitBack="emitBack"
          @emitClose="emitClose"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import breakpoint from "@/mixins/index";
import { mapGetters, mapMutations } from 'vuex'
export default {
  components: {
    'newDeliveryLocation': () => import('./NewDeliveryLocation.vue')
  },
  mixins: [breakpoint],
  props: {
    widget: {
      type: Boolean,
      default: false,
    },
    relationshipProp: {
      type: Object,
      default: () => {},
      required: true
    },
    tabsLength: {
      type: Number,
      default: 0,
      required: true
    },
    tabIndex: {
      type: Number,
      default: 0,
      required: true
    },
  },
  data() {
    return {
      pendingCreateLocation: false,
      renderKey: 0,
      buyerAccountId: "",
      deliveryLocationChangeOccured: false,
      creatingNewLocation: false,
      selectedTab: 0,
      searchLocation: "",
      selectedDeliveryLocationId: "",
      pendingNavigationTab: null,
      pendingNavigationLocationId: "",
      defaultEmptyDeliveryLocation: {
        name: "",
        notes: "",
        company: "",
        meta: {},
        address: {
          addressLine1: "",
          addressLine2: "",
          county: "",
          postCode: "",
          country: "",
        },
        contact: {
          name: "",
          phone: "",
          email: "",
        },
      },
      existingDeliveryLocations: [],
    };
  },
  computed: {
    ...mapGetters('itemRemoval', ['showItemRemovalConfirmation', 'unsavedChangesRemovalConfirmed']),
    ...mapGetters('deliveryLocations', ['getDeliveryLocationDeleted']),
    unsavedChangesFound: function(){
      const result = this.deliveryLocationChangeOccured;
      this.$emit('emit-tracked-changes', this.creatingNewLocation ? this.creatingNewLocation : result);
      return result;
    },
    filteredExisitingDeliveryLocations() {
      if (this.searchLocation) {
        let filteredData = this.existingDeliveryLocations.filter((x) => {
          return x && x.name.toLowerCase().includes(this.searchLocation.toLowerCase());
        });
        return filteredData;
      } else {
        return this.existingDeliveryLocations;
      }
    },
    currentSelectedLocation() {
      if (this.selectedDeliveryLocationId) {
        let matchingLocation = this.existingDeliveryLocations.find((x) => x._id === this.selectedDeliveryLocationId);
        return matchingLocation ? matchingLocation : this.defaultEmptyDeliveryLocation;
      } else {
        return this.defaultEmptyDeliveryLocation;
      }
    },
    showLocationDetails() {
      return (this.existingDeliveryLocations && this.existingDeliveryLocations.length) || this.creatingNewLocation;
    },
    getSelectedTab() {
      return this.selectedTab;
    }
  },
  watch: {
    showItemRemovalConfirmation(newValue, oldValue) {
      if (this.pendingCreateLocation) {
        if (oldValue && !newValue && this.unsavedChangesRemovalConfirmed) {
          this.proceedToAddingNewLocation();
        } else if (oldValue && !newValue && !this.unsavedChangesRemovalConfirmed) {
          this.$refs['locationTabs']._data.currentName = this.selectedTab;
          this.pendingCreateLocation = false;
        }
      }
      if (this.pendingNavigationTab) {
        if (oldValue && !newValue && this.unsavedChangesRemovalConfirmed) {
          this.proceedToTab(this.pendingNavigationTab)
        }
      }
      this.$store.dispatch("itemRemoval/confirmUnsavedChangesRemoval", false);
    },
    unsavedChangesFound() {},
    getDeliveryLocationDeleted(newValue) {
      if (newValue) {
        this.resetDisplay()
      }
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {
    this.buyerAccountId = this.relationshipProp.id
    if (this.widget) {
      this.creatingNewLocation = true;
    } else {
      await this.assignDeliveryLocationsList();
      // check if any existing Locations then return the first to be opened automatically
      if (this.existingDeliveryLocations && this.existingDeliveryLocations.length > 0) {
        this.selectedDeliveryLocationId = this.existingDeliveryLocations[0]._id;
      } else {
        this.addNewDeliveryLocation();
      }
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  methods: {
    ...mapMutations('deliveryLocations', ['setDeliveryLocationDeleted']),
    emitBack(){
      this.$emit('emit-back', this.tabIndex)
    },
    emitNext(){
      this.$emit('emit-next', this.tabIndex)
    },
    emitClose(){
      this.$emit('emit-close', this.tabIndex);
    },
    async resetDisplay() {
      await this.assignDeliveryLocationsList();
      this.selectedDeliveryLocationId = "";
      this.findNextAvailableDeliveryLocation();
      this.setDeliveryLocationDeleted(false);
    },
    getDeliveryLocationLabel(name, { postCode }) {
      if (name.length >  12) {
        return `${name.substring(0, 12)}... (${postCode})`;
      }
      return `${name} (${postCode})`;
    },
    async assignDeliveryLocationsList() {
      this.existingDeliveryLocations = await this.$store.dispatch("deliveryLocations/getDeliveryLocations", this.buyerAccountId);
    },
    addNewDeliveryLocation() {
      if (this.deliveryLocationChangeOccured) {
        this.pendingCreateLocation = true;
        this.$emit("changingLocationUnsavedChanges", true)
      } else {
        this.proceedToAddingNewLocation();
      }
    },
    async deleteLocation(location) {
      this.$emit("deleteLocation", location)
    },
    findNextAvailableDeliveryLocation() {
      if (this.existingDeliveryLocations && this.existingDeliveryLocations.length > 0) {
        // we set the first existing delivery Location as defualt selection
        this.selectedDeliveryLocationId = this.existingDeliveryLocations[0]._id;
        this.selectedTab = "0";
      } else {
        this.addNewDeliveryLocation();
      }
    },
    changeTab(event) {
      this.pendingNavigationTab = event.index;
      this.pendingNavigationLocationId = this.existingDeliveryLocations[event.index]._id;
      if (this.deliveryLocationChangeOccured) {
        this.$emit("changingLocationUnsavedChanges", true)
      } else {
        this.proceedToTab(event.index);
      }
      this.renderKey++;
    },
    proceedToAddingNewLocation() {
      this.selectedTab = "";
      this.selectedDeliveryLocationId = "";
      this.creatingNewLocation = true;
      this.pendingCreateLocation = false;
    },
    proceedToTab(tabIndex) {
      this.creatingNewLocation = false;
      this.selectedTab = tabIndex;
      this.selectedDeliveryLocationId = this.existingDeliveryLocations[tabIndex]._id;
      this.pendingNavigationTab = null;
      this.pendingNavigationLocationId = "";
    },
    async newDeliveryLocationCreated(newDeliveryLocationId) {
      await this.assignDeliveryLocationsList();
      if (!this.widget) {
        this.selectedDeliveryLocationId = newDeliveryLocationId;
        this.creatingNewLocation = false;
        this.selectedTab = await this.getCorrespondingTabIndex(newDeliveryLocationId);
      } else {
        this.$emit("newDeliveryLocationCreated", newDeliveryLocationId);
      }
    },
    async deliveryLocationUpdated() {
      await this.assignDeliveryLocationsList();
      this.selectedTab = await this.getCorrespondingTabIndex(this.selectedDeliveryLocationId);
    },
    async getCorrespondingTabIndex(deliveryLocationId) {
      return this.existingDeliveryLocations
        .map((location) => {
          return location._id;
        })
        .indexOf(deliveryLocationId).toString();
    },
  },
};
</script>

<style lang="scss" scoped>

::v-deep .widthFix {
  .el-tabs__header {
    &.is-left {
      width: -webkit-fill-available;
    }
  }
}

</style>
